import { render, staticRenderFns } from "./AttachDocumentSingle.vue?vue&type=template&id=2ba858d2&scoped=true&"
import script from "./AttachDocumentSingle.vue?vue&type=script&lang=js&"
export * from "./AttachDocumentSingle.vue?vue&type=script&lang=js&"
import style0 from "./AttachDocumentSingle.vue?vue&type=style&index=0&id=2ba858d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba858d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
